import { Evidence } from '@/types';

import styles from './evidence-list.module.css';

interface EvidenceListProps {
  evidences: Evidence[];
}

export function EvidenceList({ evidences }: EvidenceListProps) {
  if (evidences.length === 0) {
    return <div className={styles.empty}>暂无扣分/加分依据</div>;
  }

  return (
    <ul className={styles.list}>
      {evidences.map((evidence) => (
        <li
          key={evidence.id}
          className={
            evidence.deduction > 0 ? styles.deduction : styles.suggestion
          }
        >
          <div className={styles.header}>
            <span className={styles.dimension}>{evidence.dimension}</span>
            {evidence.deduction > 0 && (
              <span className={styles.deductionValue}>-{evidence.deduction}</span>
            )}
          </div>
          <p className={styles.description}>{evidence.description}</p>
          {evidence.location && (
            <span className={styles.location}>位置：{evidence.location}</span>
          )}
        </li>
      ))}
    </ul>
  );
}
